<h2 mat-dialog-title>{{ 'tableSettings.configColumns' | translate: _locale.language }}</h2>
<mat-dialog-content class="table-settings-dialog-content">
    <mat-selection-list
        class="table-settings-mat-selection-list"
        [(ngModel)]="_selectedColumns"
        cdkDropList
        (cdkDropListDropped)="_onDrop($event)"
        cdkDropListOrientation="vertical"
        cdkDropListLockAxis="y"
    >
        <mat-list-option
            #option
            *ngFor="let column of _columns"
            [value]="column.key"
            cdkDrag
            cdkDragPreviewContainer="parent"
            [cdkDragDisabled]="!option.selected"
        >
            <!-- stopPropagation, to avoid check || uncheck the checkbox when user clicks on drag-icon -->
            <mat-icon cdkDragHandle matListIcon (click)="$event.stopPropagation()">
                {{ option.selected ? 'drag_indicator' : '' }}
            </mat-icon>
            {{ column.label }}
        </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>
        {{ 'tableSettings.cancel' | translate: _locale.language }}
    </button>
    <button mat-button [mat-dialog-close]="this._selectedColumns" class="terra-color-active">
        {{ 'tableSettings.confirm' | translate: _locale.language }}
    </button>
</mat-dialog-actions>
